<template>
  <el-card shadow="never" class="card">
    <div slot="header" class="card-header">
      <i class="el-icon-user"></i>
      <span>游客信息</span>
    </div>

    <div class="visitor-list">
      <VisitorInfoBlock
        v-for="(item, idx) in visitors"
        :key="idx"
        :value="visitors[idx]"
        @input="onVisitorInput(idx, $event)"
        :index="idx"
        :show-remove="visitors.length > 1"
        :platform-options="platformOptions"
        :area-options="getAreaOptions(item)"
        :ticket-type-options="ticketTypeOptions"
        @remove="removeVisitor"
      />
    </div>

    <div class="add-visitor">
      <el-button icon="el-icon-plus" type="primary" plain @click="addVisitor">添加游客</el-button>
    </div>
  </el-card>
</template>

<script>
import VisitorInfoBlock from './VisitorInfoBlock.vue'

const createEmptyVisitor = () => ({
  name: '',
  idNo: '',
  phone: '',
  age: '系统将自动计算',
  ticketType: '',
  platform: '',
  area: '',
  remark: ''
})

export default {
  name: 'VisitorInfoForm',
  components: {
    VisitorInfoBlock
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    platformOptions: {
      type: Array,
      default: () => []
    },
    // areaOptions is now an object mapping platform -> [areas]
    areaOptions: {
      type: Object,
      default: () => ({})
    },
    ticketTypeOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visitors() {
      return this.value
    },
    // 让 v-model="visitorsProxy[idx]" 可用
    visitorsProxy: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  data() {
    return {
      areaOptionsMap: {}
    }
  },
  watch: {
    platformOptions: {
      handler() {
        this.buildAreaOptionsMap()
      },
      immediate: true
    },
    areaOptions: {
      handler() {
        this.buildAreaOptionsMap()
      },
      immediate: true
    }
  },
  methods: {
    buildAreaOptionsMap() {
      // areaOptions is expected to be an object: { platformName: [area1, area2] }
      this.areaOptionsMap = {}
      this.platformOptions.forEach(platform => {
        const arr = (this.areaOptions && this.areaOptions[platform]) ? this.areaOptions[platform] : []
        this.areaOptionsMap[platform] = arr.map(area => ({
          label: area,
          value: area
        }))
      })
    },
    getAreaOptions(visitor) {
      if (!visitor || !visitor.platform) return []
      return this.areaOptionsMap[visitor.platform] || []
    },
    onVisitorInput(index, updatedVisitor) {
      const next = this.value.slice()
      next.splice(index, 1, updatedVisitor)
      // debug log to verify propagation
      try {
        console.log('[VisitorInfoForm] onVisitorInput', index, updatedVisitor, next)
      } catch (e) {
        // Log unexpected errors to console for debugging
        console.error(e)
      }
      this.$emit('input', next)
    },
    addVisitor() {
      this.$emit('input', [...this.value, createEmptyVisitor()])
    },
    removeVisitor(index) {
      const next = this.value.slice()
      next.splice(index, 1)
      this.$emit('input', next)
    }
  }
 
}
</script>

<style scoped>
.card {
  margin-bottom: 16px;
  border-radius: 6px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #409eff;
  font-weight: 700;
}

.visitor-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.add-visitor {
  padding-top: 10px;
}
</style>
